package gr.tech.site.styles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.JustifyContent

val HeroContainerStyle = CssStyle {
    base {
        Modifier
            .zIndex(1)
            .textAlign(TextAlign.Center)
            .color(Colors.White)
            .padding(topBottom = 10.cssRem)
    }
    Breakpoint.MD {
        Modifier.padding(topBottom = 18.cssRem)
    }
}

val HeroSplitStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Grid)
            .gridTemplateColumns { size(1.fr) }
    }
    Breakpoint.LG {
        Modifier
            .gridTemplateColumns { size(55.fr); size(45.fr) }
            .minHeight(100.vh - 72.px)
    }
}

val HeroPhotoCellStyle = CssStyle {
    base {
        Modifier.display(DisplayStyle.None)
    }
    Breakpoint.LG {
        Modifier
            .display(DisplayStyle.Flex)
            .position(Position.Relative)
            .overflow(Overflow.Hidden)
            .backgroundColor(rgba(1, 51, 50, 1.0))
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
    }
    cssRule(":hover .hero-overlay") {
        Modifier.opacity(1.0)
    }
    cssRule(":hover .hero-iframe-wrapper") {
        Modifier.boxShadow(
            BoxShadow.of(
                offsetX = 0.px,
                offsetY = 0.px,
                blurRadius = 72.px,
                spreadRadius = 12.px,
                color = rgba(128, 192, 138, 0.7) //
            )
        )
    }
}

val HeroCopyCellStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.White)
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .justifyContent(JustifyContent.Start)
            .padding(topBottom = 48.px, leftRight = 28.px)
    }
    Breakpoint.LG {
        Modifier.padding(topBottom = 60.px, leftRight = 72.px)
    }
}

val HeroOverlayStyle = CssStyle.base {
    Modifier
        .background {
            image(
                linearGradient(135.deg) {
                    add(rgba(1, 30, 30, 0.72), 0.percent)
                    add(rgba(2, 67, 66, 0.55), 100.percent)
                }
            )
        }
        .opacity(0.8)
        .transition(Transition.of("opacity", 400.ms, AnimationTimingFunction.EaseInOut))
}

val HeroIframeContainerStyle = CssStyle.base {
    Modifier
        .width(min(88.percent, 650.px))
        .aspectRatio(16, 9)
        .borderRadius(12.px)
        .overflow(Overflow.Hidden)
        .boxShadow(BoxShadow.of(0.px, 0.px, 0.px, 0.px, rgba(0, 255, 153, 0.0)))
        .transition(Transition.of("box-shadow", 400.ms, AnimationTimingFunction.EaseInOut))
}

val HeroEyebrowStyle = CssStyle.base {
    Modifier
        .gap(10.px)
        .fontSize(10.px)
        .fontWeight(700)
        .letterSpacing(0.15.em)
        .textTransform(TextTransform.Uppercase)
}

val HeroH1Style = CssStyle.base {
    Modifier
        .fontSize(clamp(2.cssRem, 3.5.vw, 3.5.cssRem))
        .lineHeight(1.08)
}

val HeroBodyStyle = CssStyle.base {
    Modifier
        .fontSize(16.px)
        .lineHeight(1.8)
        .maxWidth(460.px)
        .fontWeight(400)
}

val HeroCtaRowStyle = CssStyle.base {
    Modifier.gap(16.px)
}

val HeroTrustLineStyle = CssStyle.base {
    Modifier
        .fontSize(12.px)
        .letterSpacing(0.02.em)
}

// Horizontal scroll card rows — fills exactly 4-across on desktop, scrolls on mobile
val HomeScrollCardItemStyle = CssStyle.base {
    Modifier
        .flexShrink(0)
        .width(25.percent - 12.px)
        .minWidth(260.px)
}

val HomeTestimonialCardStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.White)
            .borderRadius(12.px)
            .borderLeft(4.px, LineStyle.Solid, Theme.MediumGreen.rgb)
            .padding(2.cssRem)
            .height(100.percent)
            .boxShadow(
                BoxShadow.of(
                    offsetX = 0.px,
                    offsetY = 4.px,
                    blurRadius = 16.px,
                    spreadRadius = 0.px,
                    color = rgba(0, 0, 0, 0.08)
                )
            )
            .transition(Transition.all(250.ms))
    }
    hover {
        Modifier
            .boxShadow(
                BoxShadow.of(
                    offsetX = 0.px,
                    offsetY = 8.px,
                    blurRadius = 24.px,
                    spreadRadius = 0.px,
                    color = rgba(0, 0, 0, 0.15)
                )
            )
            .translateY((-2).px)
    }
}

// Growers Profile

val GrowersProfileContainer = CssStyle {
    base {
        Modifier
            .padding(16.px)
            .backgroundColor(Theme.MediumGreen.rgb)
            .borderRadius(8.px)
            .boxShadow(
                BoxShadow.of(
                    offsetX = 0.px,
                    offsetY = 8.px,
                    blurRadius = 30.px,
                    spreadRadius = 4.px,
                    color = rgba(100, 100, 111, 0.5)
                )
            )
    }
}
